var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import { ProductUtility } from '@inter-ikea-kompis/utilities';
import WaterLabelCardStyle from './WaterLabelCardStyle.js';
const LABEL_FILE_TYPE = 'svg';
/**
 * Data-driven information listing.
 */
export default class WaterLabelCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated (never used).
        this.localizedInformation = null;
        // Disables links. This attribute should be set to "true" when in a Kiosk.
        this.disableLinks = false;
    }
    /**
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${WaterLabelCardStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">${this.getCard()}</div>
		`;
    }
    getCard() {
        return html ` <div class="labels">${this.getLabels()}</div> `;
    }
    getLabels() {
        return this.getLabelUrls().map((url) => html `<img src="${url}" alt="${this.getImageAlt()}" />`);
    }
    /**
     * Return url to the label SVGs.
     */
    getLabelUrls() {
        if (this.product.content?.complianceLabel?.length) {
            return this.product.content.complianceLabel
                .filter((obj) => obj.fileType === LABEL_FILE_TYPE)
                .map((obj) => obj.url);
        }
        return [];
    }
    /**
     * Returns corresponding text to the water efficiency class image.
     */
    getImageAlt() {
        const complianceType = ProductUtility.getProductComplianceType(this.product);
        switch (complianceType) {
            case ProductComplianceTechnicalHeadingTypeEnum.unifiedWaterLabel: {
                const eecObject = this.product.content?.complianceTechnical?.find((obj) => obj.headingType === complianceType);
                const { headingText, text } = eecObject ?? {};
                return `${headingText} ${text}`;
            }
            default:
                return '';
        }
    }
}
__decorate([
    property({ type: Object, required: true })
], WaterLabelCard.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], WaterLabelCard.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], WaterLabelCard.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Boolean })
], WaterLabelCard.prototype, "disableLinks", void 0);
//# sourceMappingURL=WaterLabelCard.js.map